<template>
    <div v-cloak>
        <div :id="`${signatureType}Container`">
            <div class="row">
                <div class="col-xs-6">
                    <label
                        :for="`${signatureType}SigBox`"
                        class="control-label"
                    >
                        Signature*
                    </label>
                </div>
            </div>
            <div :id="`${this.signatureType}SigBox`" class="penCursor">
            </div>
            <input
                :id="`${signatureType}Value`"
                type="hidden"
                name="output"
                class="output"
            >
            <div class="col-xs-6">
                <b-btn
                    variant="secondary"
                    size="sm"
                    @click="clearSignature"
                >
                    <i class="fas fa-ban" /> Clear
                </b-btn>
            </div>
        </div>
    </div>
</template>

<script>
/* global $ */
/* eslint-disable-next-line */
import '../../plugins/jq-signature/jq-signature.js';

export default {
    name: 'SignaturePadComponent',
    components: {},
    mixins: [],
    props: {
        signatureType: {
            type: String,
            required: true,
        },
        value: {
            type: String,
            default: '',
        },
        config: {
            type: Object,
            default: () => ({
                background: '#eeeeee',
                lineWidth: 2,
                border: 'none',
                lineColor: '#145394',
                cursor: null
            })
        },
    },
    data() {
        return {
            signature: [],
            signaturePad: undefined,
        };
    },
    watch: {
        config() {
            this.signaturePad.updateOptions(this.config);
        },
        value() {
            // check if signature is there
            if (this.value !== '') {
                $(this.signaturePad).jqSignature('regenerate', JSON.parse(this.value));
            } else {
                this.clearSignature();
            }
        },
    },
    mounted() {
        // initialise the signature pad
        this.signaturePad = $(`#${this.signatureType}SigBox`).jqSignature(this.config);

        $(this.signaturePad).on('jq.signature.changed', function () {
            this.updateSignature();
        }.bind(this));

        this.resizeSignatureBox();
        window.onresize = () => {
            this.resizeSignatureBox();
        };

        // check if signature is there
        if (this.value !== '') {
            $(this.signaturePad).jqSignature('regenerate', JSON.parse(this.value));
        }
    },
    // beforeDestroy() {
    //     $(this.$el).signaturePad('destroy');
    // },
    methods: {
        clearSignature() {
            $(this.signaturePad).jqSignature('clearCanvas');
            this.signature = '';
            this.$emit('input', this.signature);
        },
        updateSignature() {
            this.signature = $(this.signaturePad).jqSignature('getSignatureString');
            this.$emit('input', this.signature);
        },
        resetSignatureBox() {
            $(this.signaturePad).jqSignature('destroy');
            $(this.signaturePad).empty();
            this.signaturePad = $(`#${this.signatureType}SigBox`).jqSignature(this.config);
        },
        resizeSignatureBox() {
            const width = $(window).width();
            if (width < 961) {
                this.config.width = 280;
                this.config.height = 130;
            } else {
                this.config.width = 540;
                this.config.height = 180;
            }

            this.resetSignatureBox();
            this.clearSignature();
        },
    },
};
</script>
<style>
    .penCursor canvas {
        cursor: url("../../plugins/jq-signature/pen.cur"), pointer !important;
    }
</style>
